<section class="jumbotron jumbotron-fluid home-top-jumbotron product-counter">
    <div class="container">
        <p *ngIf="firstLine" [innerHTML]="firstLineSanitized"></p>
        <p *ngIf="secondLine" [innerHTML]="secondLineSanitized"></p>
    </div>
</section>
